import { Text } from "styles/utility-components";

import { DetailsHeader, DetailsPage } from "components/app_layout/DetailsLayout";
import CognismContactsTable from "components/contacts/cognism/CognismContactsTable";
import ContactsTable from "components/contacts/ContactsTable";
import { useUnifiedContacts } from "lib/hooks/useUnifiedContacts";

export function ContactsPage() {
  // ON serves the unified, source-aware table (Oscar + Cognism via OpenSearch);
  // OFF keeps the legacy Oscar page.
  const isUnifiedContactsEnabled = useUnifiedContacts();

  return (
    <DetailsPage>
      <DetailsHeader>
        <Text h1>Buyer contacts</Text>
      </DetailsHeader>
      {isUnifiedContactsEnabled ? (
        <CognismContactsTable />
      ) : (
        <ContactsTable
          tableKey="contacts-table"
          contextSource="Buyer contacts table"
          showAllFiltersDrawer
          showDropdownFilters
        />
      )}
    </DetailsPage>
  );
}
